import { render, staticRenderFns } from "./MintalMesPrdSmeltingSlagIronList.vue?vue&type=template&id=7256f126&scoped=true&"
import script from "./MintalMesPrdSmeltingSlagIronList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingSlagIronList.vue?vue&type=script&lang=js&"
import style0 from "./MintalMesPrdSmeltingSlagIronList.vue?vue&type=style&index=0&id=7256f126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7256f126",
  null
  
)

export default component.exports